import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';

import css from './IconLinkedin.module.css';

const DIRECTION_RIGHT = 'right';
const DIRECTION_LEFT = 'left';
const DIRECTION_DOWN = 'down';
const DIRECTION_UP = 'up';
const SIZE_BIG = 'big';
const SIZE_SMALL = 'small';

const IconLinkedin = props => {
  const { className, rootClassName, direction, size } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_366_14)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EE8B51"
        />
        <path
          d="M12.9281 10.3627C13.1254 10.1405 13.2872 9.91645 13.4899 9.72623C14.1121 9.13957 14.8481 8.84445 15.7085 8.85157C16.1814 8.85512 16.6472 8.8889 17.1023 9.02045C18.1441 9.3209 18.7485 10.0391 19.0383 11.056C19.2552 11.8187 19.2943 12.6027 19.2961 13.3885C19.2996 15.0453 19.2908 16.704 19.2961 18.3609C19.2961 18.5156 19.2534 18.5565 19.1005 18.5565C18.2472 18.5493 17.3921 18.5493 16.5388 18.5565C16.3876 18.5565 16.3556 18.512 16.3556 18.3698C16.361 16.7929 16.361 15.216 16.3556 13.6373C16.3556 13.2427 16.329 12.8462 16.2188 12.4622C16.0143 11.7547 15.5076 11.3938 14.7663 11.4329C13.753 11.4862 13.2268 11.9876 13.0988 13.0169C13.0685 13.2622 13.0525 13.5093 13.0543 13.7565C13.0543 15.2907 13.0543 16.8249 13.0579 18.3591C13.0579 18.512 13.0205 18.5565 12.8641 18.5565C12.0036 18.5493 11.1432 18.5493 10.2828 18.5565C10.1441 18.5565 10.105 18.5209 10.105 18.3805C10.1085 15.344 10.1085 12.3058 10.105 9.26934C10.105 9.11823 10.1548 9.08445 10.297 9.08445C11.113 9.08979 11.9308 9.09157 12.7468 9.08445C12.8979 9.08445 12.9352 9.13245 12.9334 9.27468C12.9245 9.63734 12.9299 10 12.9299 10.3645L12.9281 10.3627Z"
          fill="#FEFEFE"
        />
        <path
          d="M8.24865 13.8329C8.24865 15.3351 8.24687 16.8374 8.25221 18.3396C8.25221 18.5067 8.21132 18.5565 8.03887 18.5547C7.18554 18.5458 6.33221 18.5476 5.47709 18.5547C5.34021 18.5547 5.29932 18.5209 5.29932 18.3805C5.30287 15.3387 5.30287 12.2969 5.29932 9.25337C5.29932 9.12715 5.32954 9.0827 5.46287 9.0827C6.32865 9.08804 7.19443 9.08981 8.06021 9.0827C8.22732 9.0827 8.24865 9.14492 8.24865 9.28892C8.24509 10.8036 8.24687 12.3183 8.24687 13.8329H8.24865Z"
          fill="#FEFEFE"
        />
        <path
          d="M8.4853 6.06936C8.4853 7.01336 7.72085 7.78136 6.77863 7.78136C5.84885 7.78136 5.0773 7.01336 5.07374 6.08358C5.07019 5.14492 5.84174 4.37158 6.78219 4.37158C7.71552 4.37158 8.48352 5.1378 8.4853 6.06758V6.06936Z"
          fill="#FEFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_366_14">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

IconLinkedin.defaultProps = {
  className: null,
  rootClassName: null,
  size: SIZE_SMALL,
};

IconLinkedin.propTypes = {
  className: string,
  rootClassName: string,
  size: oneOf([SIZE_BIG, SIZE_SMALL]),
};

export default IconLinkedin;
